export default __webpack_public_path__ + "static/media/MM_2D_gold.ad2840c1.png";